// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ReactIntl from "react-intl";
import * as Core from "@material-ui/core";
import * as App_Skeleton$DvmAdminFrontendFr from "../../../common/components/App_Skeleton.bs.js";
import * as Theme_Colors$DvmAdminFrontendFr from "../../../theme/Theme_Colors.bs.js";
import * as App_Typography$DvmAdminFrontendFr from "../../../common/App_Typography.bs.js";
import * as Order_Detail_Styles$DvmAdminFrontendFr from "./Order_Detail_Styles.bs.js";
import * as Messages_Orders_Detail$DvmAdminFrontendFr from "../../../intl/messages/orders/Messages_Orders_Detail.bs.js";
import * as Order_Detail_Page_AppBar$DvmAdminFrontendFr from "./Order_Detail_Page_AppBar.bs.js";

var skeletonBox = React.createElement(Core.Box, {
      children: null
    }, React.createElement(App_Typography$DvmAdminFrontendFr.make, {
          children: React.createElement(App_Skeleton$DvmAdminFrontendFr.make, {
                animation: /* Wave */0,
                width: "100px",
                variant: "text"
              }),
          variant: "body"
        }), React.createElement(App_Typography$DvmAdminFrontendFr.make, {
          children: React.createElement(App_Skeleton$DvmAdminFrontendFr.make, {
                animation: /* Wave */0,
                width: "80px",
                variant: "text"
              }),
          variant: "body"
        }));

var bonusItem = React.createElement(Core.Grid, {
      children: React.createElement(Core.Box, {
            children: null
          }, React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                children: React.createElement(App_Skeleton$DvmAdminFrontendFr.make, {
                      animation: /* Wave */0,
                      width: "80px",
                      variant: "text"
                    }),
                variant: "body"
              }), React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                children: React.createElement(App_Skeleton$DvmAdminFrontendFr.make, {
                      animation: /* Wave */0,
                      width: "50px",
                      variant: "text"
                    }),
                variant: "body"
              })),
      className: Order_Detail_Styles$DvmAdminFrontendFr.bonusesItemNew,
      item: true
    });

function Order_Detail_Page_Skeleton(Props) {
  var orderId = Props.orderId;
  var intl = ReactIntl.useIntl();
  return React.createElement(React.Fragment, undefined, React.createElement(Order_Detail_Page_AppBar$DvmAdminFrontendFr.make, {
                  children: Belt_Array.make(7, skeletonBox)
                }), React.createElement(Core.Grid, {
                  children: null,
                  container: true,
                  direction: "column",
                  key: "0"
                }, React.createElement(Core.Grid, {
                      alignItems: "center",
                      children: React.createElement(Core.Grid, {
                            children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                                  color: "primary",
                                  style: {
                                    fontWeight: "600"
                                  },
                                  children: "" + intl.formatMessage(orderId.includes("R") ? Messages_Orders_Detail$DvmAdminFrontendFr.reselingOrderDetail : Messages_Orders_Detail$DvmAdminFrontendFr.orderDetail) + " " + orderId.slice(6, 12) + "",
                                  variant: "h3"
                                }),
                            item: true
                          }),
                      container: true,
                      item: true,
                      style: {
                        gridColumnGap: "8px"
                      }
                    }), React.createElement(Core.Grid, {
                      children: Belt_Array.mapWithIndex([
                            Belt_Array.make(2, skeletonBox),
                            Belt_Array.make(7, skeletonBox),
                            Belt_Array.make(3, skeletonBox),
                            Belt_Array.make(5, skeletonBox),
                            Belt_Array.make(8, skeletonBox)
                          ], (function (index, row) {
                              return React.createElement(Core.Grid, {
                                          children: Belt_Array.mapWithIndex(row, (function (index, element) {
                                                  return React.createElement(Core.Grid, {
                                                              children: element,
                                                              className: Order_Detail_Styles$DvmAdminFrontendFr.detailItem,
                                                              item: true,
                                                              key: String(index)
                                                            });
                                                })),
                                          className: Order_Detail_Styles$DvmAdminFrontendFr.detailRow,
                                          container: true,
                                          item: true,
                                          key: String(index)
                                        });
                            })),
                      className: Order_Detail_Styles$DvmAdminFrontendFr.detailBox,
                      container: true,
                      direction: "column",
                      item: true
                    })), React.createElement(Core.Box, {
                  children: React.createElement(Core.Grid, {
                        children: null,
                        container: true,
                        direction: "column"
                      }, React.createElement(Core.Grid, {
                            children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                                  color: "primary",
                                  style: {
                                    fontWeight: "600"
                                  },
                                  children: "" + intl.formatMessage(Messages_Orders_Detail$DvmAdminFrontendFr.orderBonuses) + " " + orderId.slice(6, 12) + "",
                                  variant: "h3"
                                }),
                            item: true,
                            key: "0"
                          }), React.createElement(Core.Grid, {
                            children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                                  color: "textSecondary",
                                  children: React.createElement(App_Skeleton$DvmAdminFrontendFr.make, {
                                        animation: /* Wave */0,
                                        width: "200px",
                                        variant: "text"
                                      }),
                                  variant: "subtitle"
                                }),
                            item: true,
                            key: "1"
                          }), React.createElement(Core.Grid, {
                            children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                                  color: "textSecondary",
                                  children: React.createElement(App_Skeleton$DvmAdminFrontendFr.make, {
                                        animation: /* Wave */0,
                                        width: "300px",
                                        variant: "text"
                                      }),
                                  variant: "subtitle"
                                }),
                            item: true,
                            key: "2"
                          })),
                  marginTop: 3
                }), React.createElement(Core.Grid, {
                  children: React.createElement(Core.Grid, {
                        children: null,
                        container: true,
                        direction: "column",
                        item: true
                      }, React.createElement(Core.Grid, {
                            children: null,
                            container: true,
                            item: true,
                            wrap: "nowrap"
                          }, React.createElement(Core.Grid, {
                                alignItems: "flex-start",
                                children: React.createElement(Core.Grid, {
                                      alignItems: "center",
                                      children: null,
                                      container: true,
                                      item: true,
                                      spacing: 1
                                    }, React.createElement(Core.Grid, {
                                          children: React.createElement(App_Skeleton$DvmAdminFrontendFr.make, {
                                                animation: /* Wave */0,
                                                height: "10px",
                                                width: "10px",
                                                variant: "circle"
                                              }),
                                          item: true
                                        }), React.createElement(Core.Grid, {
                                          children: React.createElement(App_Skeleton$DvmAdminFrontendFr.make, {
                                                animation: /* Wave */0,
                                                width: "30px",
                                                variant: "text"
                                              }),
                                          item: true
                                        })),
                                className: Order_Detail_Styles$DvmAdminFrontendFr.bonusesItemNew,
                                container: true,
                                item: true
                              }), Belt_Array.make(8, bonusItem)), React.createElement(Core.Grid, {
                            children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                                  children: React.createElement(App_Skeleton$DvmAdminFrontendFr.make, {
                                        animation: /* Wave */0,
                                        width: "300px",
                                        variant: "text"
                                      }),
                                  variant: "caption"
                                }),
                            item: true
                          })),
                  className: Order_Detail_Styles$DvmAdminFrontendFr.helpersBoxNew,
                  container: true,
                  item: true,
                  spacing: 1,
                  style: {
                    borderLeft: "4px solid " + Theme_Colors$DvmAdminFrontendFr.primaryBrown + ""
                  }
                }));
}

var Styles;

var make = Order_Detail_Page_Skeleton;

export {
  Styles ,
  skeletonBox ,
  bonusItem ,
  make ,
}
/* skeletonBox Not a pure module */
